export const DEFAULT_MAX_NUMBER_ELEMENTS_ON_LEADERBOARD_LIST = 8;
export const DEFAULT_MIN_NUMBER_ELEMENTS_ON_LEADERBOARD_LIST = 1;
export const SIZE_INITIAL_RANKING_LIST = 10;
export const SCOPE = 'learning-leaderboard';
